import L from "leaflet";

import amenity_library from "./icons/amenity_library.png";
import tourism_museum from "./icons/tourism_museum.png";
import tourism_gallery from "./icons/tourism_gallery.png";
import amenity_theatre from "./icons/amenity_theatre.png";
import amenity_hospital from "./icons/amenity_hospital.png";
import amenity_school from "./icons/amenity_school.png";
import social_facility from "./icons/social_facility.png";
import amenity_university from "./icons/amenity_university.png";
import amenity_post_office from "./icons/amenity_post_office.png";
import amenity_police from "./icons/amenity_police.png";
import amenity_pharmacy from "./icons/amenity_pharmacy.png";
import amenity_clinic from "./icons/amenity_clinic.png";
import amenity_cinema from "./icons/amenity_cinema.png";
// import amenity_music_school from './icons/amenity_music_school.png';
import amenity_atm from "./icons/amenity_atm.png";
import amenity_place_of_worship from "./icons/amenity_place_of_worship.png";
import amenity_church from "./icons/amenity_church.png";
import amenity_bicycle_repair_station from "./icons/amenity_bicycle_repair_station.png";
import amenity_rack from "./icons/amenity_rack.png";
import next_bike from "./icons/marker-bigi.png";
import pin from "./icons/pin.png";

export const icons = {
    "amenity_library": new L.Icon({
      iconUrl: amenity_library,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "tourism_museum": new L.Icon({
      iconUrl: tourism_museum,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "tourism_gallery": new L.Icon({
      iconUrl: tourism_gallery,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_theatre": new L.Icon({
      iconUrl: amenity_theatre,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_hospital": new L.Icon({
      iconUrl: amenity_hospital,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_school": new L.Icon({
      iconUrl: amenity_school,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_university": new L.Icon({
      iconUrl: amenity_university,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_post_office": new L.Icon({
      iconUrl: amenity_post_office,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_police": new L.Icon({
      iconUrl: amenity_police,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_pharmacy": new L.Icon({
      iconUrl: amenity_pharmacy,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_clinic": new L.Icon({
      iconUrl: amenity_clinic,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_cinema": new L.Icon({
      iconUrl: amenity_cinema,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_atm": new L.Icon({
      iconUrl: amenity_atm,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_place_of_worship": new L.Icon({
      iconUrl: amenity_place_of_worship,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "amenity_church": new L.Icon({
      iconUrl: amenity_church,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "social_facility": new L.Icon({
      iconUrl: social_facility,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
    "bicycle_store": new L.Icon({
      iconUrl: amenity_bicycle_repair_station,
      iconSize: new L.Point(32, 43),
      popupAnchor: [0, -15],
    }),
  };
  

  export const nextBikeIcon = new L.Icon({
    iconUrl: next_bike,
    iconSize: new L.Point(32, 43),
    popupAnchor: [0, -15],
  });
  export const rackIcon = new L.Icon({
    iconUrl: amenity_rack,
    iconSize: new L.Point(32, 43),
    popupAnchor: [0, -15],
  });


export const customIcon = new L.Icon({
  iconUrl: pin,
  iconSize: new L.Point(40, 47),
});


